import { Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";
import { styled } from "@mui/material/styles";
import React from "react";
import { Button } from "reactstrap";
import CloseModalIcon from "../../assets/images/closeIcon.svg";
import { DialogFooter, DialogHeader } from "../ui/dialog";

interface Props {
  isOpen?: boolean;
  onCancel?: any;
  onConfirm?: any;
  title: string;
  message: React.ReactNode;
  row?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  hideCancel?: boolean;
}

// Definido fora do componente: criar o styled() a cada render gera um novo tipo
// de componente, o que faz o React desmontar e remontar o Dialog inteiro em toda
// renderização do pai. Isso dispara em cascata os efeitos de layout do Modal/Fade
// do MUI e estoura "Maximum update depth exceeded" (React #185).
const BootstrapDialog = styled(Dialog)(() => ({
  "& .MuiPaper-root": {
    borderRadius: "10px",
  },
  "& .MuiDialogContent-root": {
    // minWidth: "500px",
    // maxWidth: "1000px",
    // width: 'max-content',
    overflow: "hidden",
    padding: 0,
    // padding: theme.spacing(2),
    // background: "#EBE6E6",
  },
  "& .MuiDialogActions-root": {
    width: '100%',
    // minWidth: '800px',
    justifyContent: "flex-start",
    // padding: theme.spacing(1),
    // marginLeft: '0.850rem'
  },
  "& .MuiDialogHeader-root": {
    height: "44px",
  },
  "& .MuiDialogFooter-root": {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "54px",
  },
}));

const ModalConfirm: React.FC<Props> = ({
  onConfirm,
  onCancel,
  title,
  message,
  confirmLabel = "Confirmar",
  cancelLabel = "Cancelar",
  hideCancel = false
}: Props) => {
  return (
    <BootstrapDialog
      onClose={onCancel}
      aria-labelledby="customized-dialog-title"
      open={true}
    >
      <DialogHeader>
        <DialogTitle
          className="text-sm text-[#000] font-bold"
          id="customized-dialog-title"
        >
          {title}
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={onCancel}
          sx={(theme) => ({
            position: "absolute",
            right: 8,
            top: 2,
            color: theme.palette.grey[500],
          })}
        >
          <img src={CloseModalIcon} />
        </IconButton>
        <div className="w-full h-[1px] bg-[#ccc]" />
      </DialogHeader>

      <DialogContent>
        <>
          <div className="flex items-center justify-start p-5">
            <span className="text-base font-bold text-[#000000]">{message}</span>
          </div>
          <div className="w-full h-[1px] bg-[#ccc]" />
        </>
      </DialogContent>
      <DialogFooter>
        <div className="flex items-center justify-end p-3">
          {!hideCancel && (
            <Button
              className="w-20 h-8 rounded-full bg-[#F9FAFA] text-xs text-[#000] mr-2 font-bold"
              style={{ border: "1px solid #DBDEDF" }}
              onClick={onCancel}
            >
              {cancelLabel}
            </Button>
          )}
          <Button
            className="w-20 h-8 rounded-full bg-[#0C4A85] text-xs text-[#fff] font-bold"
            onClick={onConfirm}
          >
            {confirmLabel}
          </Button>
        </div>
      </DialogFooter>
    </BootstrapDialog>
  );
};

export default ModalConfirm;
